import { Intent } from 'signup-constants/Intent';
import { getIntentKey } from '../routing/getIntentKey';
export const isValidIntent = () => {
  const intentKey = getIntentKey();
  return Object.values(Intent).includes(intentKey);
};